import { render } from "./file.vue?vue&type=template&id=3082f8e4&scoped=true&ts=true"
import script from "./file.vue?vue&type=script&lang=ts"
export * from "./file.vue?vue&type=script&lang=ts"

import "./file.vue?vue&type=style&index=0&id=3082f8e4&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3082f8e4"]])

export default __exports__